// @ts-check

// import Base from "./base";
// import Log from "./logging";

import { makeType } from "../core/types"
import { initLog } from "../core/base"
import { maybe, getWith } from "../core/functions"

// import { Base } from "./classes";

const getClassName = app =>
    app.className == null ? getWith ("proto", "name") (app) : app.className

// if (app.className) {
//     name = app.className
// } else if (app.proto && app.proto.name) {
//     name = app.proto.name
// }
// return name

const proto = {
    name: "UI",

    apps: [], // all known "apps" (components or behaviors)
    // registry: [], // instances of apps
    // Base: Base, // deprecated: UI components can inherit from this

    initLog,

    initialize: function() {
        this.initLog ()
        // this.log.enable();
    },

    register: function(role, app) {
        // console.log(`register: ${role}`)
        UI.apps.push ({
            role: role,
            app: app
        })
    },

    // register a new dom element, after page is loaded
    evaluate: function(dom) {
        const addComponents = dom => {
            UI.apps.forEach (app => {
                dom.findByRole (app.role).forEach (instance => {
                    this.addComponent (app.role, app.app, instance)
                })
            })
        }

        const addUrls = dom => {
            const urls = [...dom.querySelectorAll ("[data-wrap-url]")]
            if (dom.dataset.wrapUrl) {
                urls.push (dom)
            }

            urls.forEach (p => {
                const x = document.createElement ("a")
                x.href = p.dataset.wrapUrl
                x.setAttribute ("class", "anchor-wrapper")
                x.wraps (p)
            })
        }

        maybe (addComponents) (dom)
        maybe (addUrls) (dom)
    },

    addComponent: function(role, app, instance) {
        const add = (role, instance) => {
            role = getClassName (app) || role

            instance.behaviors = instance.behaviors || {}

            if (instance.behaviors[role] == null) {
                const s = new app (instance)
                instance.behaviors[role] = s
                UI[role] = app
            }
        }

        maybe (add) (role, instance)
    }
}

const d = makeType (proto)
const UI = new d ()

document.addEventListener ("DOMContentLoaded", () => {
    UI.apps.forEach (app => {
        document.findByRole (app.role).forEach (instance => {
            UI.addComponent (app.role, app.app, instance)
        })
    })
})

// temporary: added here, so it is included in different builds of the core library
const isInViewport = function() {
    const rect = this.getBoundingClientRect ()

    return (
        // top is in viewport
        (rect.top > 0 &&
            rect.top <=
                (window.innerHeight ||
                    document.documentElement.clientHeight)) ||
        // bottom is in viewport
        (rect.bottom > 0 &&
            rect.bottom <=
                (window.innerHeight || document.documentElement.clientHeight))
    )
}

Element.implement ({
    isInViewport: isInViewport
})

export default UI
